export default {
  computed: {
    /**
     * These getters and setters basically split the luxon date into separate
     * date - time strings for the individual datetime pickers
     */
    startDate: {
      get () {
        return this.luxon.fromSQL(this.event.start_date).toSQLDate()
      },
      set (val) {
        // Date is invalid if its 30th Feb (etc)
        if (!val) {
          return
        }
        const [year, month, day] = val.split('-')
        this.event.start_date = this.luxon.fromSQL(this.event.start_date)
          .set({ year, month, day })
          .toSimpleSQL()
      }
    },
    startTime: {
      get () {
        return this.luxon.fromSQL(this.event.start_date).toFormat(this.luxonFormats.TIME_24HR)
      },
      set (val) {
        const [hour, minute] = val.split(':')
        this.event.start_date = this.luxon.fromSQL(this.event.start_date)
          .set({ hour, minute })
          .toSimpleSQL()
      }
    },
    endDate: {
      get () {
        return this.luxon.fromSQL(this.event.end_date).toSQLDate()
      },
      set (val) {
        // Date is invalid if its 30th Feb (etc)
        if (!val) {
          return
        }
        const [year, month, day] = val.split('-')
        this.event.end_date = this.luxon.fromSQL(this.event.end_date)
          .set({ year, month, day })
          .toSimpleSQL()
      }
    },
    endTime: {
      get () {
        return this.luxon.fromSQL(this.event.end_date).toFormat(this.luxonFormats.TIME_24HR)
      },
      set (val) {
        const [hour, minute] = val.split(':')
        this.event.end_date = this.luxon.fromSQL(this.event.end_date)
          .set({ hour, minute })
          .toSimpleSQL()
      }
    }
  },
  methods: {
    /**
     * Start date shouldn't be later than the end date
     * (and vice versa)
     */
    onUpdateStartDate () {
      if (this.luxon.fromSQL(this.endDate) < this.luxon.fromSQL(this.startDate)) {
        this.endDate = this.luxon.fromSQL(this.startDate).toSQLDate()
      }
    },
    onUpdateEndDate () {
      if (this.luxon.fromSQL(this.startDate) > this.luxon.fromSQL(this.endDate)) {
        this.startDate = this.luxon.fromSQL(this.endDate).toSQLDate()
      }
    },
    baseIsOutsideBusinessHours (hours) {
      if (!hours || this.startDate !== this.endDate) {
        return false
      }
      const startTime = this.luxon.fromFormat(hours.start_time, 'HH:mm')
      const endTime = this.luxon.fromFormat(hours.end_time, 'HH:mm')

      return startTime > this.luxon.fromFormat(this.startTime, 'HH:mm') || endTime < this.luxon.fromFormat(this.endTime, 'HH:mm')
    }
  }
}
